import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {UserEditModalComponent} from '../modal-edit/modal-edit.component';
// service
import {UserService} from '../service/user.service';
import {ApiUserService} from '../service/api-user.service';

// model

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [UserEditModalComponent]
})

export class HeaderComponent implements OnInit {

  searchPlaceholder;
  isLoggedIn: boolean;
  currentRoute;
  currentUserObserver;
  currentUser;

  constructor(private userService: UserService,
              public apiUserService: ApiUserService,
              private router: Router) {

    router.events.subscribe((event) => {
      this.isLoggedIn = userService.isLoggedFullIn();

    });

  }

  ngOnInit() {
    this.currentUserObserver = this.userService.currentUserSubject.subscribe((result) => {
      if (result !== null) {
        this.currentUser = result;
      } else {
        this.currentUser = this.userService.currentUser;
      }
    })

    // get current route
    this.apiUserService.routerSubject
      .subscribe((val) => {
        this.currentRoute = val;
        if (val.aka === 'main') {
          this.searchPlaceholder = 'users';
        } else if (val.aka === 'org') {
          this.searchPlaceholder = 'organisations';
        } else if (val.aka === 'orguser') {
          this.searchPlaceholder = 'api users';
        }else if (val.aka === 'orguserActivate') {
          this.searchPlaceholder = 'orguserActivate';
        }
      });
  }

  search(val: any) {
    this.userService.setSearchValue(val);
  }

  logoutUser() {
    this.userService.logout();
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts